import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import ModuleDisplayDateTime from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayDate from "../../../../UI/modules/fieldsDisplay/ModuleDisplayDate";
import ModuleDisplayRichText from "../../../../UI/modules/fieldsDisplay/ModuleDisplayRichText";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import { Link } from "react-router-dom";


const Details = ({ item, confirmAndStop, confirmAndStart }) => {
  const getItems = () => {
    let items = [];
    if (item.target) {
      items = [...items, { text: "Target", value: item.target, type: "text" }];
    }

    if (item.resultType) {
      items = [...items, { text: "Show Results On", value: item.resultType, type: "text" }];
    }

    if (item.target && (item.target !== "All-Members" && item.target !== 'Attach-to-Activity')) {
      items = [
        ...items,

        {
          text:
            "Target " +
            (item.target === "Selected-Circles"
              ? " Circles "
              : item.target === "Selected-Members"
                ? " Members "
                : null) +
            "Count",
          value:
            item.target === "Selected-Circles"
              ? item.targetedCirclesCount
                ? item.targetedCirclesCount
                : "Targets not added yet"
              : item.target === "Selected-Members"
                ? item.targetedMembersCount
                  ? item.targetedMembersCount
                  : "Targets not added yet"
                : 0,
          type: "text",
        },
      ];
    }

    if (item.activityId) {
      items = [
        ...items,
        {
          text: "Attached Activity",
          value: item.attachedActivity.title,
          type: "text"
        }
      ];
    }
    return items;
  };

  return (
    <>
      <Row>
        <Col>
          <Card className="item  mb-2">
            <Card.Header className="ps-1 pe-2 py-0">
              <Card.Title className="m-0 p-0 ">
                <div className="d-flex ImageSectionSpacing">
                  <div className="position-relative ms-1 me-2">
                    <div className="ms-1 me-2">
                      <i className="fas fa-poll position-relative usericon ">
                        {(item.status === "disabled") && (
                          <i className="fas fa-ban position-absolute banned"></i>
                        )}
                      </i>
                    </div>
                  </div>

                  <div className="d-flex flex-column ms-1">
                    <span className="m-0 text-bold memberName">
                      {item.title} {item.isAnnounced === "1" && <span className="result-announced"> (<i class="fa fa-trophy mx-1" aria-hidden="true"></i>Result Announced )</span>}
                    </span>

                    <span className=" font-small font-weight-normal text-success fs-6 mt-1 ">
                      <span className="cutsomText-red">
                        Total Questions - {item.questionsCount}
                      </span>
                    </span>
                  </div>
                </div>
              </Card.Title>

              <div className="card-tools">
                <div className=" text-right mt-xl-0 mt-1">

                  {(item.status === "disabled") && (
                    <span className="badge badge-secondary me-1 text-white">
                      Disabled
                    </span>
                  )}
                  {(item.status === "notStarted") && (
                    <span className="badge badge-dark  me-1 text-white">
                      Not Started
                    </span>
                  )}
                  {(item.status === "begun") && (
                    <span className="badge badge-success  me-1 text-white">
                      Begun
                    </span>
                  )}
                  {(item.status === "finished" && item.isAnnounced === "0") && (
                    <span className="badge badge-info  me-1 text-white">
                      Finished
                    </span>
                  )}
                  {(item.status === "finished" && item.isAnnounced === "1") && (
                    <span className="badge badge-primary  me-1 text-white">
                      Results Announced
                    </span>
                  )}
                  {(item.status === "archived") && (
                    <span className="badge badge-warning  me-1 text-dark">
                      Archived
                    </span>
                  )}

                  <span class="badge badge-light me-1 text-dark">
                    Created Date/Time :{" "}
                    <span class="text-secondary">
                      <ModuleDisplayDateTime value={item.createdAt} />{" "}
                    </span>
                  </span>
                </div>

                <div class=" text-right me-xl-2  mt-1 mb-1 ">

                  {(item.status === "begun") && (
                    <span
                      title="Finished Poll"
                      onClick={() => confirmAndStop(item._id)}
                      class="btn btn-sm btn-outline-primary  listingActionIcon me-1"
                    >
                      <i class="fas fa-stop me-1"></i> Finish Poll
                    </span>
                  )}

                  {(item.status === "finished") && (
                    <span
                      title="Start Poll"
                      onClick={() => confirmAndStart(item._id)}
                      class="btn btn-sm btn-outline-primary  listingActionIcon me-1"
                    >
                      <i className="fas fa-play me-1"></i> Start Poll
                    </span>
                  )}

                  <Link
                    class="btn btn-sm btn-outline-primary  listingActionIcon"
                    title="View Item details"
                    to={`/poll-submissions/${item._id}`}
                  >
                    <i class="fas fa-list"></i> &nbsp; View Submission(s)
                  </Link>

                  <Link
                    class="btn btn-sm btn-outline-primary  listingActionIcon ml-1"
                    title="View Item details"
                    to={`/poll-stats/${item._id}`}
                  >
                    <i class="fas fa-chart-bar"></i> &nbsp; View Stats
                  </Link>
                </div>
              </div>
            </Card.Header>

            <Card.Body className="p-2">
              <StatsListing items={getItems()} />



              {item.description && (
                <p>
                  <div class="badge badge-light me-1 text-dark mt-1 mb-1 p-2 font-small d-flex">
                    Description :
                  </div>
                  <div class="me-1  mt-1 mb-1 p-2 ">
                    <ModuleDisplayRichText value={item.description} />
                  </div>
                </p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Details;
